import 'dayjs/locale/fr';
import { useNavigate } from 'react-router-dom';
import { useParams, useSearchParams } from "react-router-dom";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import CallIcon from '@mui/icons-material/Call';
import CONFIG from '../../../config';
import dayjs from 'dayjs';
import EuroIcon from '@mui/icons-material/Euro';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import GroupsIcon from '@mui/icons-material/Groups';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import React from 'react';
import sha256 from 'crypto-js/sha256';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetInputTextList from '../../../components/widgets/WidgetInputTextList';
import WidgetProgress from '../../../components/widgets/WidgetProgress';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import WorkIcon from '@mui/icons-material/Work';
import FicheInfo from './FicheInfo';
import Questionnaire from '../../client/questionnaire/Questionnaire';
import Dossier from '../../client/dossier/Dossier';
import FicheDocuments from './FicheDocuments';
import WidgetInputVille from '../../../components/widgets/WidgetInputVille';
import WidgetDropZone from '../../../components/widgets/WidgetDropZone';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Divider, IconButton, Tab, Tabs } from '@mui/material';
import DocumentState from '../../client/dossier/DocumentState';
import FicheWidgetCommercial from './FicheWidgetCommercial';
import WidgetFile from '../../../components/widgets/WidgetFile';
import Dropzone from 'react-dropzone';
import FicheAdmin from './FicheAdmin';
import QuestionnaireLocataire from '../../client/questionnaire_locataire/QuestionnaireLocataire';
import QuestionnaireGarant from '../../client/questionnaire_garant/QuestionnaireGarant';
import FicheMetaGroupDocuments from './FicheMetaGroupDocuments';
import FolderIcon from '@mui/icons-material/Folder';
import SavingsIcon from '@mui/icons-material/Savings';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';


function FicheEtatDossierGarant({ user, setUser, i }) {
  const { id } = useParams();
  const [message, setMessage] = React.useState(null);


  return (
    <>
      {user !== null &&
        (
          <>
            <div className='grid grid-cols-12 gap-x-4 py-6 px-6 bg-white my-shadow'>
              <div className='flex col-span-12 w-full text-center justify-between'>
                <div className='flex text-center items-center'>
                  <div className='pr-4 w-48 text-start'>
                    <h3>Etat garant n°{i + 1}</h3>
                  </div>

                  <div className='pr-4 w-32 text-start'>
                    {(user.dossier.list_garants[i].etat == 'incomplet' && user.dossier.avancement_dossier !== 1) ? (
                      <>
                        <div className='col-span-4 w-full flex items-center justify-end gap-4 text-red-600 font-medium'>
                          <div className='inline-block'>Incomplet</div>
                          <div className='inline-block'><CloseIcon /></div>
                        </div>
                      </>
                    ) : (
                      (user.dossier.list_garants[i].etat == 'complet' || (user.dossier.list_garants[i].etat == 'incomplet' && user.dossier.avancement_dossier === 1)) ? (
                        <>
                          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-orange-400 font-medium'>
                            <div className='inline-block'>Déposé</div>
                            <div className='inline-block'><MoreHorizIcon /></div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-green-600 font-medium'>
                            <div className='inline-block'>Validé</div>
                            <div className='inline-block'><CheckIcon /></div>
                          </div>
                        </>
                      )
                    )}
                  </div>
                </div>

                <div className='flex text-center items-center'>
                  <div className='pr-2 w-96'>
                    <WidgetInputText state={message} setState={setMessage} id={'message'} text={"Commentaire"} size="small" value={user.dossier.list_garants[i].message} />
                  </div>

                  <div className=''>
                    <IconButton onClick={() => {
                      let payload = { 'message': message.value, 'rejet': true };
                      axios.post(CONFIG.API_URL + '/api/retour_garant_total/' + user._id + '/' + i, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                        .then((response) => {
                          switch (response.status) {
                            case 200:
                              setUser(response.data);
                              break;

                            default:
                              break;
                          }
                        })
                        .catch((e) => {
                          let response = e.response;

                          if (response === undefined) {
                            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                            return;
                          }

                          switch (response.status) {
                            default:
                              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                              break;
                          }
                        });
                    }}><CancelIcon className='text-red-500'></CancelIcon></IconButton>
                  </div>

                  <div className=''>
                    <IconButton onClick={() => {
                      let payload = { 'message': message.value, 'rejet': false };
                      axios.post(CONFIG.API_URL + '/api/retour_garant_total/' + user._id + '/' + i, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                        .then((response) => {
                          switch (response.status) {
                            case 200:
                              setUser(response.data);
                              break;

                            default:
                              break;
                          }
                        })
                        .catch((e) => {
                          let response = e.response;

                          if (response === undefined) {
                            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                            return;
                          }

                          switch (response.status) {
                            default:
                              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                              break;
                          }
                        });
                    }}><CheckCircleIcon className='text-green-500'></CheckCircleIcon></IconButton>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }
    </>
  );
}

export default FicheEtatDossierGarant;